import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgDuplicate = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10 8V18H16V8H10ZM8 6H18V20H8V6ZM6 4V15H4V2H13V4H6Z"
      fill="currentColor"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgDuplicate);

export default ForwardRef;
